import Button from "../../../../components/world/rmc/Button";
import { FullModal } from "./fullModal";

export const CheckSuccessModal = ({ handleCloseModal, data, primaryColor = "#FFD700" }) => {
  return (
    <FullModal>
      <div className="px-4 pt-16 relative">
        <div className="flex items-center gap-5 flex-col">
          <Check color={primaryColor} />
          <div>
            <p className="mb-2 text-center text-2xl text-white">
              Check-In Successful!
            </p>
            <p className="max-w-[215px] text-xs font-medium leading-tight text-center">
              You now entered into the draw.
            </p>
          </div>
          <div className="w-full flex flex-col gap-5">
            <div className="flex w-full items-center justify-between gap-3 p-5 rounded-[10px] bg-[#1A1F33]">
              <p className="text-[#FFFFFFBF] font-semibold">Your Ticket</p>
              <p className="py-2 px-4 rounded-full bg-[#111522] text-[#FFFFFFBF] text-xs border border-[#252B41]">
                ID: {data?.ticket_id}
              </p>
            </div>
            <div className="w-full flex items-center gap-5 justify-between">
              <div className="p-4 rounded-[10px] w-1/2 bg-[#1A1F33] flex items-center gap-2.5">
                <Coin color={primaryColor} />
                <div>
                  <p className="text-white font-medium">
                    {data?.coined_earned}
                  </p>
                  <p className="font-medium text-[#FFFFFF80] text-xs">
                    Coined earned
                  </p>
                </div>
              </div>
              <div className="bg-[#1A1F33] w-1/2 p-4 rounded-[10px] flex items-center gap-2.5">
                <Calendar color={primaryColor} />
                <div>
                  <p className="font-medium text-white">2-Day Streak</p>
                  <p className="font-medium text-[#FFFFFF80] text-xs">
                    Keep it going
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col gap-5 mt-12">
            <Button
              onClick={handleCloseModal}
              text="Return Home"
              className="text-lg py-[18px]"
              style={{ backgroundColor: primaryColor }}
            />
          </div>
        </div>
      </div>
    </FullModal>
  );
};

const Check = ({ color = "#FFD700" }) => {
  return (
    <svg
      width="67"
      height="68"
      viewBox="0 0 67 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4993 67.3332C15.0893 67.3332 0.166016 52.4098 0.166016 33.9998C0.166016 15.5898 15.0893 0.666504 33.4993 0.666504C51.9093 0.666504 66.8327 15.5898 66.8327 33.9998C66.8327 52.4098 51.9093 67.3332 33.4993 67.3332ZM29.576 41.1332L20.3593 31.9098L16.8327 35.4365L27.2293 45.8398C27.8544 46.4647 28.7021 46.8158 29.586 46.8158C30.4699 46.8158 31.3176 46.4647 31.9427 45.8398L51.7827 26.0065L48.2427 22.4665L29.576 41.1332Z"
        fill={color}
      />
    </svg>
  );
};

const Calendar = ({ color = "#FFD700" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0007 6.66667V4M10.0007 6.66667V4M4.33398 10.6667H27.6673M13.678 18.9893L15.0567 20.564C15.1833 20.7093 15.4113 20.6973 15.5233 20.5427L18.3233 16.6667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 13.3922C4 10.5722 4 9.1615 4.58133 8.08416C5.1067 7.12301 5.92245 6.35253 6.912 5.88283C8.05333 5.3335 9.54667 5.3335 12.5333 5.3335H19.4667C22.4533 5.3335 23.9467 5.3335 25.088 5.88283C26.092 6.3655 26.9067 7.13616 27.4187 8.08283C28 9.16283 28 10.5735 28 13.3935V19.9428C28 22.7628 28 24.1735 27.4187 25.2508C26.8933 26.212 26.0775 26.9825 25.088 27.4522C23.9467 28.0002 22.4533 28.0002 19.4667 28.0002H12.5333C9.54667 28.0002 8.05333 28.0002 6.912 27.4508C5.92265 26.9815 5.10692 26.2115 4.58133 25.2508C4 24.1708 4 22.7602 4 19.9402V13.3922Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Coin = ({ color = "#F2BC1A" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0002 30.9852C23.9199 30.9852 30.3402 24.5649 30.3402 16.6452C30.3402 8.72541 23.9199 2.30518 16.0002 2.30518C8.08039 2.30518 1.66016 8.72541 1.66016 16.6452C1.66016 24.5649 8.08039 30.9852 16.0002 30.9852Z"
        fill={color}
      />
      <path
        d="M2.63477 20.3702V21.8352C2.78477 22.2227 2.95227 22.6052 3.13477 22.9752V20.3702H2.63477ZM4.26977 23.1277V24.8877C4.46977 25.1702 4.67727 25.4477 4.89477 25.7152V23.1277H4.26977ZM6.43477 25.4277V27.3252C6.67727 27.5427 6.92727 27.7502 7.18477 27.9502V25.4277H6.43477ZM9.09977 27.1752V29.2152C9.34477 29.3502 9.59477 29.4777 9.84977 29.6002V27.1752H9.09977ZM12.1223 28.2877V30.4477C12.3698 30.5177 12.6198 30.5802 12.8723 30.6377V28.2877H12.1223ZM15.6598 28.6727V30.9752C15.7723 30.9777 15.8848 30.9827 15.9998 30.9827C16.1373 30.9827 16.2748 30.9752 16.4098 30.9727V28.6727H15.6598ZM19.1973 28.2702V30.6202C19.4498 30.5627 19.6998 30.4977 19.9473 30.4277V28.2702H19.1973ZM22.2123 27.1427V29.5702C22.4673 29.4477 22.7173 29.3152 22.9623 29.1777V27.1427H22.2123ZM24.8698 25.3802V27.9052C25.127 27.704 25.3772 27.4939 25.6198 27.2752V25.3802H24.8698ZM27.7723 23.0727H27.1473V25.6602C27.3648 25.3902 27.5748 25.1127 27.7723 24.8277V23.0727ZM29.3973 20.3052H28.8973V22.9152C29.0798 22.5377 29.2473 22.1502 29.3973 21.7577V20.3052Z"
        fill={color}
        fillOpacity="0.55"
      />
      <path
        d="M16.0002 29.6951C23.9199 29.6951 30.3402 23.2749 30.3402 15.3551C30.3402 7.43537 23.9199 1.01514 16.0002 1.01514C8.08039 1.01514 1.66016 7.43537 1.66016 15.3551C1.66016 23.2749 8.08039 29.6951 16.0002 29.6951Z"
        fill={color}
        fillOpacity="0.3"
      />
      <path
        d="M16 28.4175C23.2142 28.4175 29.0625 22.5692 29.0625 15.355C29.0625 8.14076 23.2142 2.29248 16 2.29248C8.78578 2.29248 2.9375 8.14076 2.9375 15.355C2.9375 22.5692 8.78578 28.4175 16 28.4175Z"
        fill={color}
      />
      <path
        d="M2.91309 15.8551C2.82059 14.1351 3.11809 12.3901 3.71809 10.7551C4.34309 9.12508 5.30059 7.61758 6.50809 6.33758C8.93309 3.77258 12.4531 2.28508 16.0006 2.26758C19.5481 2.28758 23.0706 3.77258 25.4906 6.34008C26.7006 7.61758 27.6556 9.12758 28.2806 10.7551C28.8831 12.3926 29.1806 14.1351 29.0856 15.8551H29.0356C29.0304 14.1393 28.6907 12.4409 28.0356 10.8551C27.3792 9.27101 26.4205 7.83 25.2131 6.61258C24.0049 5.39644 22.5693 4.42977 20.9881 3.76758C19.4073 3.10747 17.7112 2.76757 15.9981 2.76757C14.285 2.76757 12.5889 3.10747 11.0081 3.76758C9.42687 4.42977 7.9913 5.39644 6.78309 6.61258C5.57514 7.8296 4.61638 9.27071 3.96059 10.8551C3.30546 12.4409 2.96579 14.1393 2.96059 15.8551H2.91309Z"
        fill={color}
        fillOpacity="0.7"
      />
      <path
        d="M16.0002 1.01758C8.08016 1.01758 1.66016 7.43758 1.66016 15.3576C1.66016 23.2776 8.08016 29.6976 16.0002 29.6976C23.9202 29.6976 30.3402 23.2776 30.3402 15.3576C30.3402 7.43758 23.9202 1.01758 16.0002 1.01758ZM16.0002 28.4201C8.78516 28.4201 2.93766 22.5726 2.93766 15.3576C2.93766 8.14008 8.78516 2.29258 16.0002 2.29258C23.2152 2.29258 29.0627 8.14008 29.0627 15.3551C29.0627 22.5701 23.2152 28.4201 16.0002 28.4201Z"
        fill={color}
        fillOpacity="0.3"
      />
      <path
        d="M9.4982 5.3374L9.8157 6.3199L10.8507 5.9249V6.3199L10.0132 6.9274L10.3332 7.5124V7.9099L9.4982 7.3024L8.6607 7.9099V7.5124L8.9807 6.9274L8.1457 6.3199V5.9249L9.1782 6.3199L9.4982 5.3374ZM5.5032 10.9774L5.8232 11.9599L6.8557 11.5649V11.9599L6.0207 12.5674L6.3407 13.1549V13.5499L5.5032 12.9424L4.6682 13.5499V13.1549L4.9882 12.5674L4.1507 11.9599V11.5649L5.1857 11.9599L5.5032 10.9774ZM5.3857 17.9299L5.7057 18.9124L6.7382 18.5174V18.9124L5.9032 19.5199L6.2232 20.1074V20.5024L5.3857 19.8949L4.5507 20.5024V20.1074L4.8707 19.5199L4.0332 18.9124V18.5174L5.0682 18.9124L5.3857 17.9299ZM9.6507 23.4499L9.9707 24.4324L11.0032 24.0374V24.4324L10.1682 25.0399L10.4882 25.6249V26.0224L9.6507 25.4149L8.8157 26.0224V25.6249L9.1357 25.0399L8.2982 24.4324V24.0374L9.3332 24.4324L9.6507 23.4499ZM22.5032 5.3374L22.1857 6.3199L21.1507 5.9249V6.3199L21.9882 6.9274L21.6682 7.5124V7.9099L22.5032 7.3024L23.3407 7.9099V7.5124L23.0207 6.9274L23.8557 6.3199V5.9249L22.8232 6.3199L22.5032 5.3374ZM26.4982 10.9774L26.1782 11.9599L25.1457 11.5649V11.9599L25.9807 12.5674L25.6607 13.1549V13.5499L26.4982 12.9424L27.3332 13.5499V13.1549L27.0132 12.5674L27.8507 11.9599V11.5649L26.8157 11.9599L26.4982 10.9774ZM26.6157 17.9299L26.2957 18.9124L25.2632 18.5174V18.9124L26.0982 19.5199L25.7782 20.1074V20.5024L26.6157 19.8949L27.4507 20.5024V20.1074L27.1307 19.5199L27.9682 18.9124V18.5174L26.9332 18.9124L26.6157 17.9299ZM22.3507 23.4499L22.0307 24.4324L20.9982 24.0374V24.4324L21.8332 25.0399L21.5132 25.6249V26.0224L22.3507 25.4149L23.1857 26.0224V25.6249L22.8657 25.0399L23.7032 24.4324V24.0374L22.6682 24.4324L22.3507 23.4499Z"
        fill={color}
        fillOpacity="0.6"
      />
      <path
        d="M22.3505 23.0524L22.668 24.0349H23.703L22.8655 24.6424L23.1855 25.6249L22.3505 25.0174L21.513 25.6249L21.833 24.6424L20.998 24.0349H22.0305L22.3505 23.0524ZM26.6155 17.5349L26.933 18.5174H27.968L27.1305 19.1249L27.4505 20.1074L26.6155 19.4999L25.778 20.1074L26.098 19.1249L25.263 18.5174H26.2955L26.6155 17.5349ZM26.498 10.5824L26.8155 11.5649H27.8505L27.013 12.1724L27.333 13.1549L26.498 12.5474L25.6605 13.1549L25.9805 12.1724L25.1455 11.5649H26.178L26.498 10.5824ZM22.503 4.93994L22.823 5.92244H23.8555L23.0205 6.52994L23.3405 7.51244L22.503 6.90494L21.668 7.51244L21.988 6.52994L21.1505 5.92244H22.1855L22.503 4.93994Z"
        fill={color}
        fillOpacity="0.35"
      />
      <path
        d="M16.0127 25.625L16.3327 26.6075L17.3652 26.2125V26.6075L16.5302 27.215L16.8502 27.8025V28.1975L16.0127 27.59L15.1777 28.1975V27.8025L15.4977 27.215L14.6602 26.6075V26.2125L15.6952 26.6075L16.0127 25.625Z"
        fill={color}
        fillOpacity="0.6"
      />
      <path
        d="M16.0127 25.1001L16.3327 26.0826H17.3652L16.5302 26.6901L16.8502 27.6726L16.0127 27.0651L15.1777 27.6726L15.4977 26.6901L14.6602 26.0826H15.6952L16.0127 25.1001Z"
        fill={color}
        fillOpacity="0.35"
      />
      <path
        d="M16.0127 3.22266L16.3327 4.20516L17.3652 3.81016V4.20516L16.5302 4.81266L16.8502 5.40016V5.79516L16.0127 5.18766L15.1777 5.79516V5.40016L15.4977 4.81266L14.6602 4.20516V3.81016L15.6952 4.20516L16.0127 3.22266Z"
        fill={color}
        fillOpacity="0.6"
      />
      <path
        d="M16.0132 2.82764L16.3332 3.81014H17.3657L16.5307 4.41764L16.8507 5.40014L16.0132 4.79264L15.1782 5.40014L15.4982 4.41764L14.6607 3.81014H15.6957L16.0132 2.82764ZM9.6507 23.0526L9.3332 24.0351H8.2982L9.1357 24.6426L8.8157 25.6251L9.6507 25.0176L10.4882 25.6251L10.1682 24.6426L11.0032 24.0351H9.9707L9.6507 23.0526ZM5.3857 17.5351L5.0682 18.5176H4.0332L4.8707 19.1251L4.5507 20.1076L5.3857 19.5001L6.2232 20.1076L5.9032 19.1251L6.7382 18.5176H5.7057L5.3857 17.5351ZM5.5032 10.5826L5.1857 11.5651H4.1507L4.9882 12.1726L4.6682 13.1551L5.5032 12.5476L6.3407 13.1551L6.0207 12.1726L6.8557 11.5651H5.8232L5.5032 10.5826ZM9.4982 4.94014L9.1782 5.92264H8.1457L8.9807 6.53014L8.6607 7.51264L9.4982 6.90514L10.3332 7.51264L10.0132 6.53014L10.8507 5.92264H9.8157L9.4982 4.94014Z"
        fill={color}
        fillOpacity="0.35"
      />
    </svg>
  );
};
